// schemas/candidate.ts
import { z } from "zod";
import { options } from "../constants.schema";

export const languageVideoSchema = z.object({
  language_video: z.object(options).optional(),
  file: z
    .instanceof(File)
    .refine((f) => f.type.startsWith("video/"), {
      message: "Only video files (mp4, webm, mov, avi, mpeg…) are accepted.",
    })
    .optional(),
});

export type LanguageVideoType = z.infer<typeof languageVideoSchema>;
